export default "__VITE_ASSET__OddIOyLI__"